import React from 'react'
import style from "./CardFeature.module.scss"


function CardFeature({ logo, title, text, animacion, duration }) {
    return (

        <div className={style.container} data-aos={animacion} data-aos-duration={duration}>
            <div className={style.container__svg}>
                <i className={logo}></i>
            </div>
            <h2>{title}</h2>
            <p>{text}</p>
        </div>
    )
}

export default CardFeature